<script lang="ts">
    import type {ContractDocument} from "$lib/types/todos";
    import {Button, Modal, Spinner, Tooltip} from "flowbite-svelte";
    import {DownloadOutline, EyeOutline, PenNibSolid} from "flowbite-svelte-icons";
    import ModalHeader from "$lib/components/ui/ModalHeader.svelte";
    import ModalFooter from "$lib/components/ui/ModalFooter.svelte";
    import convertPdfToImage from "$lib/utils/convertPdfToImage";
    import {getContext, onMount} from "svelte";
    import CopyToClipboard from "$lib/components/CopyToClipboard.svelte";
    import type {Writable} from "svelte/store";
    import type {Employee} from "$lib/types/employee";

    export let value: ContractDocument
    let open = false;

    let employee:Writable<Employee> = getContext('employee')

    let previews: string[] = [];
    const render = async () => {
        open = true;
        try{
            if(value.location.includes('sign.celest.services')){
                value.location += '?direct-download=true'
            }
            const converted = await convertPdfToImage(value.location);
            converted.forEach((preview) => {

                previews = [...previews, preview]
            })
        } catch (e) {
            console.error(e)
        }


    }

    onMount(() => {

        console.log({employee: $employee, passIn: value})
    })


</script>
<div class="flex gap-2">
    {#if !value?.location}
        <span>Kein Dokument</span>
    {:else}
        {#if !value.signedByEmployee}
            <CopyToClipboard textToCopy={$employee.contracts.find(x => x.id === value.contractId)?.history?.find(x => x.id === value.historyId)?.employeeSignatureLink }>
                <Button size="xs" color="primary" >
                    <PenNibSolid class="h-3 w-3"/>
                </Button>
                <Tooltip>Signatur-link</Tooltip>
            </CopyToClipboard>
        {:else}
            <Button size="xs" color="alternative" on:click={() => window.open(value.location, '_blank')}>
                <DownloadOutline class="h-3 w-3"/>
            </Button>
            <Tooltip>Download</Tooltip>
        {/if}
        <Button size="xs" color="alternative" on:click={() => render()}>
            <EyeOutline class="h-3 w-3"/>
        </Button>
        <Tooltip>Open</Tooltip>
    {/if}

</div>
<Modal size="lg" bind:open>
    <svelte:fragment slot="header"><ModalHeader title="Dokument"/></svelte:fragment>
    {#if previews.length > 0}
        {#each previews as preview,i}
            <div class="text-center mb-3">Seite {i+1}</div>
            <img src={preview} alt="Seite-{i+1}">
        {/each}
    {:else}
        <Spinner />
    {/if}
    <svelte:fragment slot="footer">
        <ModalFooter nextText="Download" on:next={() => window.open(value.location, '_blank')} />
    </svelte:fragment>
</Modal>
